<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { api } from '../api/Api'
import TextInput from '../components/ui/form/TextInput.vue'
import AmountInput from '../components/ui/form/AmountInput.vue'
import CheckInput from '../components/ui/form/CheckInput.vue'
import MessageBoxService from '../services/MessageBox'
import { toBool } from '../utils/CommonFunctions'
import { tokenManager } from '../api/utils/tokenManager'
import { Settings } from '../types/models'
import SearchSelect from '../components/ui/form/SearchSelect.vue'
//import SearchSelect from '../components/ui/form/SearchSelect.vue'

const activeTab = ref('general')

const activeSetting = ref<Settings>()
const settings = ref<Settings[]>([])
async function getSettings() {
 
  const response = await api.post(
    "system/company/settings/get"
  );
  if (response.success == true) {
    let set = response.data as Settings[]
    set.forEach(sec => {
      sec.sub_section?.forEach ( sub => {
        sub.settings?.forEach(setting => {
          if (setting.field_type == 'number') {
            setting.value = parseInt(setting.value as string || '0')
          } else if (setting.field_type == 'check') {
            setting.value = toBool(setting.value || false)
          }
        });
      })
    });
    settings.value = set
    activeSetting.value = set[0]
  }
}

const getSelectItems = (text: string): string[] => {
  return [...new Set(text.split(",").map(item => item.trim()))];
}

const handleSave = async () => {
  const params = {
    'settings': settings.value
  }
  const response = await api.post(
    "system/company/settings/update", params
  );
  if (response.success == true) {
    tokenManager.setSettings(response.data)
    MessageBoxService.show("Settings saved", 'info')
  }
}

onMounted(() => {
  getSettings()
})

</script>

<template>
  <div class="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-100 dark:border-gray-800">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 dark:border-gray-800">
      <h2 class="text-2xl font-semibold text-gray-900 dark:text-white">Settings</h2>
    </div>

    <div class="flex flex-col md:flex-row h-[calc(100vh-12rem)]" v-if="settings">
      <!-- Sidebar for Desktop, Dropdown for Mobile -->
      <div class="w-full md:w-64 border-b md:border-b-0 md:border-r border-gray-100 dark:border-gray-800">
      <nav class="p-4">
        <div class="md:hidden">
        <select
          v-model="activeSetting"
          class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
        >
          <option v-for="setting in settings" :key="setting.uid" :value="setting">
          {{ setting.caption }}
          </option>
        </select>
        </div>
        <ul class="hidden md:block space-y-1">
        <li v-for="setting in settings" :key="setting.uid">
          <button
          @click="activeSetting = setting"
          class="w-full px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          :class="[
            activeTab === setting.uid
            ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400'
            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800'
          ]"
          >
          <span>{{ setting.icon }}</span>
          {{ setting.caption }}
          </button>
        </li>
        </ul>
      </nav>
      </div>

      <div class="flex-1 overflow-y-auto" v-if="activeSetting">
      <div class="p-6">
        <div class="space-y-6">
        <div class="grid grid-cols-1 gap-6" v-for="section in activeSetting.sub_section">
          <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {{ section.caption }}
          </label>
          </div>
          <div class="grid md:grid-cols-2 gap-6">
          <div v-for="key in section.settings">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {{key.caption}}
            </label>
            <TextInput v-if="key.field_type === 'text'" v-model="key.value" label="" />
            <TextInput v-if="key.field_type === 'password'" v-model="key.value" label="" type="password"/>
            <AmountInput v-if="key.field_type == 'number'" v-model="key.value" label="" />
            <SearchSelect v-if="key.field_type == 'db_field' || key.field_type == 'db_list'" v-model="key.value" label="" :end-point="key.extra_values" />

            <select
            v-if="key.field_type == 'list'"
            v-model="key.value"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            >
            <option v-for="item in getSelectItems(key.extra_values || '')" :key="item" :value="item">{{ item }}</option>
            </select>

            <!--<SearchSelect
            label=""
            v-if="key.field_type == 'db_list'"
            :end-point="key.extra_values"
            v-model="key.value"
            />-->

            <CheckInput v-if="key.field_type == 'check'" v-model="key.value" label="" />
            
          </div>
          </div>
        </div>
        </div>
      </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-100 dark:border-gray-800 flex justify-end">
      <button
        @click="handleSave"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>